import { CREATIVE_TYPE } from '@ad-lucy/config/creatives';
import { useCreativesConfig } from '@ad-lucy/context';

import useLiveRenderingVideoPlay from './bp/useLiveRenderingVideoPlay';

const BPEffects = () => {
  useLiveRenderingVideoPlay();
  return null;
};

export function useCreativeEffects() {
  const { id: creativeId } = useCreativesConfig();

  if (creativeId === CREATIVE_TYPE.BP) {
    return <BPEffects />;
  }

  return null;
}
